import { render, staticRenderFns } from "./CommonPropertyAd.vue?vue&type=template&id=63d9bd9a&scoped=true&"
import script from "./CommonPropertyAd.vue?vue&type=script&lang=js&"
export * from "./CommonPropertyAd.vue?vue&type=script&lang=js&"
import style0 from "./CommonPropertyAd.vue?vue&type=style&index=0&id=63d9bd9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d9bd9a",
  null
  
)

export default component.exports